import { Instance, SnapshotOut, types } from "mobx-state-tree"

/**
 * # Detail
 * 
 * Detail을 설명하세요.
 */
export const Detail = types
  .model("Detail")
  // --------------------------------------------------------------------------
  .props({
    errmsg: types.optional(types.string, ''),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model Detail --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IDetail;
      (Object.keys(newProps) as TDetailKeys[]).forEach((key) => {
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TDetail = Instance<typeof Detail>;
type TDetailSnapshot = SnapshotOut<typeof Detail>

export interface IDetail extends TDetail {}
export type TDetailKeys = keyof TDetailSnapshot & string;
export interface IDetailSnapshot extends TDetailSnapshot {}
export const createDetail = () => 
  types.optional(Detail, {} as TDetail);